var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BodyPart } from './body-part';
import DIMS from './dimensions.js';
import { GRAVITY } from './constants.js';
import { Vector3, RotatePinnedVector, midpoint } from '../util/vector-utils.js';
import { Quaternion } from './quaternion';
var Torso = (function (_super) {
    __extends(Torso, _super);
    function Torso(params) {
        var _this = _super.call(this, params) || this;
        _this.moment = function (momentArmOrigin) {
            var force = new Vector3(0, GRAVITY * _this.mass, 0);
            var moment = _this.pCenterMass.subtract(momentArmOrigin);
            moment.cross(force);
            return moment;
        };
        var shoulderJointDistance = (_this.width + DIMS.UPPER_ARM_WIDTH) / 2;
        _this.jointVector = {
            'right-upper-arm': new Vector3(0, -shoulderJointDistance, 0),
            'left-upper-arm': new Vector3(0, shoulderJointDistance, 0),
            'neck': new Vector3(0, 0, _this.height),
        };
        return _this;
    }
    Torso.prototype.update = function (proximal) {
        var _this = this;
        this.proximal = proximal;
        var neckDistal = RotatePinnedVector(this.proximal, this.jointVector.neck, this.qModel);
        this.pCenter = midpoint(this.proximal, neckDistal);
        this.pCenterMass = RotatePinnedVector(this.proximal, this.cmVector, this.qModel);
        Object.keys(this.joints).forEach(function (joint) {
            _this.distal[joint] = RotatePinnedVector(neckDistal, _this.jointVector[joint], _this.qModel);
            _this.joints[joint].update(_this.distal[joint], _this.qModel);
        });
    };
    Torso.prototype.updateFromKeypoints = function (torsoPoints) {
        var left = new Vector3(torsoPoints.p0);
        var right = new Vector3(torsoPoints.p1);
        var torsoVector = right.subtract(left);
        this.qModel = Quaternion.fromBetweenVectors([0, 0, 1], torsoVector.normalize().toArray());
    };
    return Torso;
}(BodyPart));
export { Torso };
//# sourceMappingURL=torso.js.map